import { render, staticRenderFns } from "./ClientSettingsStylesTabpanel.vue?vue&type=template&id=75ff8b48&"
import script from "./ClientSettingsStylesTabpanel.vue?vue&type=script&lang=js&"
export * from "./ClientSettingsStylesTabpanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ff8b48')) {
      api.createRecord('75ff8b48', component.options)
    } else {
      api.reload('75ff8b48', component.options)
    }
    module.hot.accept("./ClientSettingsStylesTabpanel.vue?vue&type=template&id=75ff8b48&", function () {
      api.rerender('75ff8b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Game/ClientSettingsStylesTabpanel.vue"
export default component.exports